import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";

export default function Stats() {
  const { t } = useLang();
  return (
    <section id="stats" data-testid="stats-section" className="relative bg-black py-20 md:py-28 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/5">
          {t.stats.items.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`stat-item-${i}`}
              className="bg-black p-8 md:p-10 group hover:bg-[#0a0a0a] transition-colors"
            >
              <div className="flex items-baseline gap-2">
                <div className="font-display text-6xl md:text-7xl text-white group-hover:text-[#FFCC00] transition-colors">
                  {s.val}
                </div>
                <div className="w-2 h-2 bg-[#FFCC00] rotate-45" />
              </div>
              <div className="mt-4 text-xs md:text-sm tracking-[0.2em] uppercase text-white/60">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
